import React from "react";
import { WidgetProps } from "@rjsf/core";
import { dateValueToFormat } from "../../../constants/formats";

interface IDatePicker extends WidgetProps {
  type?: string
}

const DatePickerDisplay = (props: IDatePicker) => {
  const {
    id,
    value,
    options,
    schema,
    formContext,
  } = props

  const schemaFormat = options.format || schema.format
  const valueAsDate = dateValueToFormat(value, schemaFormat as "date" | "time" | "date-time")
  let valueText = value ? valueAsDate : formContext.emptyValue;

  return (
    <div id={id} className="DatePickerDisplay">
      {valueText}
    </div>
  )
}


export default DatePickerDisplay;
